// The Settings screens from the side menu (app/screens/HomeSettingsScreen.js
// and app/screens/HomeSettings/*), and the home address from Home's "+".
export const APP_SETTINGS_PATHS = Object.freeze({
  HOME: "/settings",
  THEME: "/settings/theme",
  VOLTAGE: "/settings/voltage",
  SUBSCRIPTION: "/settings/subscription",
  HOME_ADDRESS: "/settings/home-address",
});
